// i18n area 'networks' — locale uk-UA (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.uk-UA.meta.json.
import type { enUS } from './networks'

export const ukUA: typeof enUS = {
  networks: {
    common: {
      name: 'Назва',
      scope: 'Скоуп',
      operState: 'Стан',
      actions: 'Дії',
      create: 'Створити',
      close: 'Закрити',
      cancel: 'Скасувати',
      delete: 'Видалити',
      edit: 'Змінити',
      save: 'Зберегти',
      editError: 'Не вдалося змінити',
      search: 'Пошук за назвою',
      empty: 'Тут поки що нічого немає',
      saveError: 'Не вдалося зберегти',
      loadError: 'Не вдалося завантажити — чи доступний бекенд TVirt?',
      createError: 'Не вдалося створити',
      deleteError: 'Не вдалося видалити',
      deleteConfirmTitle: 'Видалити {name}?',
      deleteConfirmBody: 'Операція незворотна.',
      nameHint: 'Малі літери, цифри та дефіси (DNS-1123)',
      up: 'Активна',
      down: 'Неактивна',
      unknown: 'Невідомо',
      usedByVMs: 'ВМ',
      emptyTable: 'Записів немає — додайте запис кнопкою +'
    },
    dialogTabs: {
      general: 'Загальне',
      base: 'Базове визначення',
      advanced: 'Розширена конфігурація',
      reserved: 'Діапазони, зарезервовані для TVirt',
      position: 'Розташування',
      network: 'Мережева конфігурація',
      hosts: 'Вузли-учасники'
    },
    reservedRanges: {
      note: 'Це діапазони IP, зарезервовані для TVirt, які він може використовувати для автоматичного призначення адрес ВМ, контейнерам тощо. УВАГА: адреси з цих діапазонів не повинні використовуватися поза TVirt зовнішніми службами чи пристроями.',
      from: 'Від',
      to: 'До'
    },
    overlay: {
      title: 'Оверлейні мережі',
      createTitle: 'Створити оверлейну мережу',
      editTitle: 'Змінити оверлейну мережу',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — призначається автоматично, якщо поле порожнє',
      subnet: 'Підмережа',
      subnetHint: 'CIDR оверлею — IPAM автоматично виводить із нього запис реєстру',
      mtu: 'MTU',
      weight: 'Вага',
      ceilMbps: 'Стеля (Мбіт/с)',
      fairnessHint: 'Вага діє лише за конкуренції: на вільному каналі кожна мережа може використовувати всю смугу. Стеля ж діє завжди.',
      contention: 'Конкуренція',
      contentionTip: 'Щонайменше один вузол бачить втрати або overlimit З чергою на класі цієї мережі: смуга uplink оспорюється і ваги діють. Скільки і відколи — у серіях net.shaping.* вузла.',
      firewallPolicy: 'Політика брандмауера',
      hosts: 'Хости',
      hostsTitle: 'Вузли-учасники',
      hostsHint: 'Кожен вузол оголошує свою кінцеву точку в андерлеї — вибір зі СПРАВЖНІХ адрес вузла, прочитаних з його мережевої конфігурації; необов’язкова адреса в оверлеї має належати підмережі. Участь є обмеженням розміщення.',
      hostNode: 'Вузол',
      hostUnderlay: 'IP андерлею',
      hostUnderlayPickNode: 'Спершу оберіть вузол',
      hostAddress: 'Адреса в оверлеї (необов’язково)',
      hostAddressOutside: 'Поза підмережею overlay ({cidr})',
      addHost: 'Додати вузол',

      // Раунд #156 (стандартний діалог): спостережені рядки діалогу деталей.
      observedAt: 'Спостережено',
      attachedNics: 'Підключені NIC'
    },
    services: {
      title: 'Мережеві служби',
      createTitle: 'Створити мережеву службу',
      editTitle: 'Змінити мережеву службу',
      kind: 'Тип',
      kindCategory: 'Служби',
      selectKindHint: 'Оберіть тип служби — демон, що працює під нею, є деталлю реалізації, якою TVirt керує за вас.',
      kindLabel: {
        dhcp: 'Сервер DHCP',
        ntp: 'Сервер NTP',
        vpn: 'Сервер VPN',
        dns: 'Сервер DNS',
        gateway: 'Шлюз',
        'lb-rp': 'Балансувальник навантаження та зворотний проксі',
        floatip: 'Плаваюча IP'
      },
      kindDesc: {
        dhcp: 'Призначає адреси в обслуговуваних підмережах — пули виводяться з підмережі, шлюзу та зарезервованих для TVirt діапазонів мережі.',
        dns: 'Авторитетний DNS для оголошених зон — записи виводяться з IPAM плюс ваші ручні.',
        gateway: 'Вузол працює шлюзом для мережі — NAT (DNAT, 1:1, SNAT/маскарадинг) плюс статична маршрутизація між підключеними мережами, самовідновна за задумом.',
        'lb-rp': 'Балансувальник / зворотний проксі перед вашими сервісами — L4 або L7 слухачі над пулами учасників або над готовими екземплярами Pod, переконфігуровані на льоту.',
        ntp: 'Служба часу для мереж — ретрансляція зовнішніх серверів вищого рівня або годинник обслуговуючого вузла, що подається клієнтам.',
        vpn: 'Концентратор VPN на вузлі — WireGuard або OpenVPN, обирайте самі: віддалений доступ для мобільних клієнтів або тунель між двома мережами.',
        floatip: 'Одна адреса, що перебуває лише на одному здоровому екземплярі App чи Pod водночас і переходить до наступної здорової цілі, коли та падає — failover без демонів; балансування лишається балансувальнику.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Плаваюча IP живе в обраній мережі як ДОДАТКОВА адреса всередині простору імен екземпляра-власника: без портів, без балансування, без NAT — IP клієнта лишається справжньою.',
        address: 'Плаваюча IP',
        targets: 'Цілі',
        targetsHint: 'У порядку ПЕРЕВАГИ: перша здорова ціль тримає адресу. Pod означає всі його екземпляри за репліками; кожна ціль має власний критерій здоров\'я. Кожна ціль має бути під\'єднана до тієї ж мережі.',
        targetKind: 'Ціль',
        targetApp: 'Екземпляр App',
        targetPod: 'Pod (усі екземпляри)',
        targetRef: 'Який',
        health: 'Здоров\'я',
        healthRunning: 'Працює (кожен контейнер готовий)',
        healthTcp: 'TCP-з\'єднання',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Порт',
        path: 'Шлях',
        addTarget: 'Додати ціль',
        moveUp: 'Перемістити вгору',
        moveDown: 'Перемістити вниз',
        preempt: 'Preempt',
        preemptHint: 'Вимкнено (типово): здоровий власник зберігає адресу, навіть коли повертається вища ціль — без метань. Увімкнено: адресу завжди тримає перша здорова ціль.',
        holder: 'Власник',
        noHolder: 'немає здорової цілі',
        since: 'з',
        verdicts: 'Спостережувані цілі',
        healthy: 'здорова',
        unhealthy: 'нездорова',
        noVerdict: 'Ще не вирішено — вузол-авторитет запише перший вердикт на наступному проході.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Цей екземпляр тримає плаваючу IP {address} сервісу {service}'
      },
      poolSource: 'Кінцеві точки',
      poolSourceMembers: 'Статичні учасники',
      poolSourcePod: 'Готові екземпляри Pod',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Порт',
      poolBackendHint: 'Кінцеві точки слідують за Pod: екземпляр входить, коли працює з кожним готовим контейнером, і одразу виходить, коли його зменшують або він помирає. Активна перевірка типово увімкнена.',
      poolBackendCount: 'готові екземпляри Pod {pod} на порту {port}',
      node: 'Вузол',
      enabled: 'Увімкнено',
      parked: 'Припарковано',
      subnets: 'Підмережі',
      subnetsHint: 'Підмережі IPAM, які обслуговує цей екземпляр — пули виводяться з CIDR, шлюзу та зарезервованих для TVirt діапазонів',
      noSubnets: 'Немає жодної підмережі IPAM — спершу оголосіть логічну мережу фабрики (або підмережу оверлею): IPAM виводиться з них',
      iface: 'Інтерфейс прослуховування',
      ifaceHint: 'Інтерфейс хоста, на якому служба відкриває свій сокет (наприклад, міст) — обовʼязковий: мережева служба самодостатня, «усі інтерфейси» більше не існує',
      dns: 'Сервер DNS',
      domain: 'Домен',
      detail: 'Обслуговує',
      subnetCount: '{n} підмереж',
      zones: 'Зони',
      zonesHint: 'Лише авторитетний — демон ніколи не робить рекурсивних запитів. Записи A виводяться з оголошених адрес вузлів у зазначених підмережах IPAM; перемикач зворотної зони додає обслуговування відповідних зон in-addr.arpa (PTR). Одну зону обслуговує щонайбільше один екземпляр DNS у флоті. Необов’язковий сервер імен — це FQDN, який записується в NS/SOA замість типового ns.<зона>; якщо він потрапляє всередину зони, його запис A все одно виводиться з обслуговуючого вузла.',
      zoneName: 'Назва зони',
      zoneNs: 'Сервер імен (NS)',
      zoneSubnets: 'Підмережі IPAM',
      zoneReverse: 'Зворотна зона (PTR)',
      zoneRecords: 'Ручні записи',
      zoneRecordsHint: 'По одному на рядок: назва ТИП значення — типи A, CNAME, MX, TXT. У разі збігу назв ручний запис перемагає виведений.',
      addZone: 'Додати зону',

      // lb-rp (хвиля 3, фундамент): слухачі на вбудованих пулах — без окремого
      // рушія, переналаштовуються на льоту.
      lbListeningHint: 'Екземпляр оголошує ОДНУ мережу прослуховування та ОДНУ адресу — кожен слухач привʼязує її на своєму порту; друга адреса — це друга служба.',
      listeners: 'Слухачі',
      listenersHint: 'Кожен слухач привʼязує адресу екземпляра на своєму порту в режимі L4 (TCP passthrough — байти ніколи не відкриваються) або L7 (HTTP) і пересилає в один із пулів нижче. Пару адреса/порт обслуговує щонайбільше один екземпляр на вузол. Зміни застосовуються на льоту — без перезапуску, без втрачених зʼєднань.',
      listenerName: 'Назва',
      listenerMode: 'Режим',
      modeL7: 'L7 — зворотний проксі HTTP',
      modeL4: 'L4 — наскрізний TCP',
      listenerPort: 'Порт',
      listenerPool: 'Пул',
      addListener: 'Додати слухача',
      pools: 'Пули',
      poolsHint: 'Бекенди, куди приземляється трафік: статичні учасники, збалансовані циклічно або за найменшою завантаженістю, з необов’язковою активною перевіркою стану, яка виводить з ротації хворих учасників.',
      poolName: 'Назва',
      poolAlgorithm: 'Алгоритм',
      algoRoundRobin: 'Циклічний',
      algoLeastRequest: 'Найменш завантажений',
      poolCheck: 'Перевірка стану',
      checkNone: 'Немає',
      checkTcp: 'З’єднання TCP',
      checkHttp: 'HTTP',
      poolCheckPath: 'Шлях проби',
      poolInterval: 'Інтервал (с)',
      poolMembers: 'Учасники',
      poolMembersHint: 'По одному на рядок: адреса:порт, за бажанням із вагою (1-128) — напр. 10.0.0.21:8080 2',
      addPool: 'Додати пул',
      memberCount: '{n} учасників',

      // ntp (раунд ntp — ратифіковано 2026-08-03, останній kind родини):
      // режим людською мовою, список серверів вищого рівня лише там, де він
      // щось означає, підключення до мережі повторює мітки шлюзу.
      listen: {
        assignment: 'Призначення',
        assignmentStatic: 'Статична адреса',
        assignmentAuto: 'Автоматично (зарезервовані діапазони TVirt)',
        autoHint: 'TVirt витягає адресу із зарезервованих діапазонів логічної мережі і тримає її sticky — ніколи не витягається заново при редагуванні чи failover.',
        title: 'Слухачі',
        hint: 'Мережева служба самодостатня: кожен слухач оголошує свою мережу (overlay, логічну мережу fabric або сирий інтерфейс) та адресу всередині її підмережі — один слухач на адресу, wildcard більше не існує. DNS і NTP можуть слухати в кількох мережах і на кількох адресах цих мереж.',
        address: 'Адреса прослуховування',
        add: 'Додати слухача'
      },
      ntp: {
        mode: 'Режим синхронізації',
        modeRelay: 'Ретрансляція зовнішніх серверів',
        modeNodeClock: 'Годинник вузла',
        modeHint: 'Ретрансляція подає час, узятий з оголошених серверів вищого рівня; годинник вузла подає час обслуговуючого вузла — який кластер і так тримає синхронізованим',
        servers: 'Сервери вищого рівня',
        serversHint: 'Через кому — ім’я хоста або IP-адреса; служба бере час звідси і подає його в мережу',
        port: 'Порт прослуховування',
        listening: 'Слухає на'
      },

      vpn: {
        engine: 'Рушій',
        engineHint: 'Обираєте ви, і потім він не змінюється: WireGuard сучасний, швидкий і працює в ядрі; OpenVPN — ветеран сумісності (TCP, ворожі мережі)',
        engineLocked: 'Рушій незмінний — інший рушій означає нову службу, ключі та сертифікати не переносяться',
        mode: 'Режим',
        modeRemote: 'Віддалений доступ',
        modeSite: 'Між майданчиками',
        modeHint: 'Віддалений доступ дає мобільним клієнтам адресу в тунелі; режим між майданчиками об’єднує дві мережі',
        port: 'Порт прослуховування',
        protocol: 'Транспорт',
        protocolWireguardHint: 'WireGuard говорить лише UDP',
        tunnelSubnet: 'Підмережа тунелю',
        tunnelSubnetHint: 'Мережа, у якій живуть клієнти — реєструється в реєстрі IPAM, народжується і вмирає разом із цією службою',
        dnsServers: 'DNS, що передаються клієнтам',
        routes: 'Маршрути, що передаються клієнтам',
        routesHint: 'Мережі через кому, доступні в тунелі; підмережа тунелю включена завжди',
        peers: 'Піри',
        peersHint: 'Залиште відкритий ключ порожнім — і TVirt згенерує пару, а потім віддасть її разом із профілем. Вставте ключ — і пір лишиться зі своїм.',
        clients: 'Клієнти',
        clientsHint: 'Кожен клієнт отримує сертифікат, виданий центром сертифікації цієї служби. Вилучення клієнта ВІДКЛИКАЄ його: CRL перегенеровується одразу.',
        peerName: 'Назва',
        publicKey: 'Відкритий ключ',
        publicKeyMinted: 'Його згенерує TVirt',
        peerAddress: 'Адреса в тунелі',
        peerAddressHint: 'Порожньо = призначається',
        allowedIps: 'Віддалені підмережі',
        allowedIpsHint: 'Через кому, маршрутизуються через цього піра',
        endpoint: 'Кінцева точка',
        presharedKey: 'Попередньо спільний ключ',
        keepalive: 'Підтримання з’єднання (с)',
        addPeer: 'Додати піра',
        addClient: 'Додати клієнта',
        auth: 'Автентифікація',
        authTls: 'Сертифікати (TLS)',
        remote: 'Віддалена кінцева точка',
        remoteHint: 'хост:порт віддаленого боку — порожньо означає, що цей бік чекає',
        peerRoutes: 'Віддалені підмережі',
        serverPublicKey: 'Відкритий ключ цього сервера',
        ca: 'Центр сертифікації',
        listening: 'Слухає на',
        tunnel: 'Тунель',
        peerCount: '{n} пірів',
        download: 'Завантажити профіль',
        downloadError: 'Не вдалося експортувати профіль',
        lastHandshake: 'Останнє рукостискання',
        never: 'ніколи',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'З’єднано',
        idle: 'Неактивний'
      },

      // Шлюз (хвиля 3 — народився як nat, ратифіковано 2026-08-01/02;
      // перейменований і розширений 2026-08-03): три родини правил NAT плюс
      // статичні маршрути на мережі прослуховування. Кожна ратифікована форма підтримується.
      gateway: {
        attach: 'Тип мережі прослуховування',
        attachOverlay: 'Оверлейна мережа',
        attachNetwork: 'Логічна мережа фабрики',
        attachInterface: 'Сирий інтерфейс',
        overlay: 'Оверлейна мережа',
        network: 'Логічна мережа',
        interface: 'Назва інтерфейсу',
        interfaceHint: 'Інтерфейс хоста, яким TVirt не керує — адреса береться на віру',
        address: 'Адреса прослуховування (шлюз)',
        addressHint: 'Адреса шлюзу, на яку вказують клієнти — усередині підмережі мережі прослуховування',
        dnatTitle: 'Правила DNAT',
        dnatHint: 'NAT призначення: трафік, що збігся, перенаправляється на нову адресу (і, за бажанням, на новий порт). Будь-який протокол зі списку — з портами там, де протокол їх має.',
        snatTitle: 'Правила SNAT',
        snatHint: 'NAT джерела: трафік, що збігся, виходить із переписаним джерелом — новою явною адресою (і, за бажанням, новим портом) або маскарадингом на адресу виходу, якщо поле порожнє.',
        oneToOneTitle: 'Правила NAT 1:1',
        oneToOneHint: 'Кожен пакет на зовнішню адресу відображається на внутрішню, а внутрішній хост виходить під зовнішньою — усі протоколи, обидва напрямки.',
        external: 'Зовнішня адреса',
        internal: 'Внутрішня адреса',
        addOneToOne: 'Додати правило 1:1',
        family: 'Родина',
        protocol: 'Протокол',
        source: 'Джерело (адреса/підмережа)',
        destination: 'Призначення (адреса/підмережа)',
        invert: 'NOT',
        srcPorts: 'Порти джерела',
        dstPorts: 'Порти призн.',
        dstPortsHint: 'Порт або діапазон (80, 8000-8099)',
        toAddress: 'Нова адреса',
        toPort: 'Новий порт',
        snatTo: 'Нове джерело (порожньо = маскарадинг)',
        snatToHint: 'Явна адреса джерела; порожньо = маскарадинг на адресу виходу',
        addDnat: 'Додати правило DNAT',
        addSnat: 'Додати правило SNAT',
        routesTitle: 'Статичні маршрути',
        routesHint: 'Вузол маршрутизує між мережами, до яких підключений (IP-форвардинг увімкнено); ці маршрути додають досяжність поза ними — чисте ядро, динамічна маршрутизація прийде в наступному раунді.',
        routeDestination: 'Підмережа призначення',
        routeGateway: 'Наступний перехід',
        routeMetric: 'Метрика',
        addRoute: 'Додати маршрут',
        listening: 'Слухає на',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} маршрутів'
      },
      unknownSince: 'Невідомо — останній звіт {m} хв тому',
      lastWord: 'Останнє слово',

      // Раунд #156 (стандартний діалог): спостережені рядки та зведення
      // блоку kind у режимі лише для читання в діалозі деталей.
      reportObservedAt: 'Останній звіт',
      lastErrorRow: 'Остання помилка',
      recordsCount: '{n} ручних записів',
      phase: {
        configured: 'Налаштовано',
        running: 'Виконується',
        error: 'Помилка'
      },
      authorityNode: 'Авторитетний вузол (призначення)',
      preferredNode: 'Бажаний вузол',
      preferredNodeHint: 'М’яка перевага, ніколи не обмеження: при наступному рішенні про розміщення екземпляр приземляється тут, якщо цей учасник придатний — сама по собі вона нічого не переносить; хід — це «Передати авторитет».',
      noPreference: 'Без переваги (автоматичне розміщення)',
      moving: 'У русі',
      movingTooltip: 'Спостерігається тут, поки авторитетний вузол призначає {node}: перенесення саме узгоджується.',
      placement: {
        title: 'Розміщення',
        loading: 'Триває перепис…',
        loadError: 'Перепис розміщення не відповів — спробуйте пізніше.',
        draftHint: 'Перепис обчислюється з оголошеного підключення мережі: він з’явиться, щойно службу буде створено. Створення відхиляється, коли жоден учасник не може її обслуговувати, і відмова називає механізм, що спорожнив множину.',
        eligibleCount: '{n} з {m} учасників можуть обслуговувати цей екземпляр',
        recommended: 'Рекомендовано',
        eligible: 'Придатний',
        notEligible: 'Непридатний',
        blockedReachability: 'мережа не доходить до цього учасника',
        blockedRequireTag: 'заблокований обов’язковим тегом (requireNodes)',
        blockedExcluded: 'виключений симуляцією',
        preferenceUnknown: 'не є (більше) учасником кластера',
        preferenceIgnored: 'Перевага «{node}» сьогодні непридатна: {reason}. Гору бере рекомендація перепису — ніколи не помилка, служба живе деінде.',
        emptyReachability: 'Жоден учасник не може обслуговувати цей екземпляр: мережа не доходить нікуди — жодне виправлення тегів не допоможе. Прокладіть кабель до вузла або перенесіть службу туди, де мережа є.',
        emptyRequireTag: 'Жоден учасник не може обслуговувати цей екземпляр: множину спорожнили обов’язкові теги — приберіть запис із requireNodes або призначте тег учасникові.',
        spof: 'Єдина точка відмови',
        spofDetail: 'Прихистити екземпляр може рівно один учасник: при відмові аварійному перемиканню нікуди йти. Служба з кількома слухачами переїжджає як ЄДИНЕ ЦІЛЕ — кандидат мусить бачити ВСІ її мережі: така ціна.',
        whatIf: 'Симулювати відсутніх учасників',
        whatIfHint: 'Питання «а що, як» звільнення вузла: спитайте ДО евакуації, а не дізнавайтеся це при аварійному перемиканні.',
        survives: 'Без {nodes} служба все ще має дім.',
        notSurvives: 'Евакуація {nodes} залишає цю службу НЕПРАЦЮЮЧОЮ: похідне обмеження перемагає доступність (R30) — демон, живий там, куди мережа не доходить, нікому не служить і нікого не тривожить.',
        transfer: 'Передати авторитет',
        transferError: 'Передача не вдалася',
        transferTarget: 'Цільовий учасник',
        transferHint: 'Пропонуються лише придатні учасники — перевага всередині допустимої множини, ніколи не перевизначення. Жодного завдання: наступний прохід воркерів І Є перенесенням (старий вузол пожинає, новий втілює).'
      }
    },
    fabric: {
      tabDerivation: 'Деривація',
      importNetwork: 'Імпортувати з іншого fabric',
      importTitle: 'Імпортувати логічну мережу',
      importHint: 'Імпорт — це явне приєднання: мережа лишається у власника (та сама ідентичність, той самий stem, той самий bridge tvf-<stem>), і звідси вона мапиться на порти/LAGG цього fabric — мапити ОЗНАЧАЄ стверджувати, що доставка виходить у той самий домен L2, що й у власника.',
      importPick: 'Мережа власника',
      importNone: 'Нічого імпортувати: інші fabric не мають власної мережі, якої цей fabric ще не знає',
      importedNetworksTitle: 'Імпортовані мережі',
      noImported: 'Немає імпортованих мереж',
      importedFrom: 'імпортована з {fabric}',
      importedBy: 'Імпортували: {list}',
      importedCount: '+{n} імпортованих',
      owner: 'Власник',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Прибрати імпорт',
      unimportConfirm: 'Прибрати імпорт мережі {name} (власник {fabric}) з цього fabric? Відхиляється, поки порт або LAGG цього fabric її мапить, або гість, App чи сервіс обслуговуються лише через цю ногу.',
      unimportRefused: 'Імпорт ще використовується — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Цей вузол уже отримує цю мережу з іншого fabric, членом якого він є: вузол бере спільну мережу лише ОДНІЄЮ зі своїх ніг (два аплінки одного L2 у bridge без STP — це петля). Зніміть мапінг на портах або LAGG одного з двох fabric.',
          otherFabricDerived: 'Документ несе блок fabric, до якого вузол більше не оголошує кабель: спершу застосуйте план того fabric (він пропонує видалити його пристрої) або заберіть їх через take-ownership, якщо fabric більше немає.'
        },
        hint: 'План деривації O.3: для кожного закабельованого вузла стан, diff похідне-vs-поточне, ОГОЛОШЕНА топологія бондів, dual-stack-фліпи та структуровані відмови/попередження. Лише читання до ЯВНОГО apply — ніщо ніколи не приземляється на вузол само.',
        refresh: 'Перезавантажити план',
        empty: 'Жоден вузол не закабельований до цієї fabric (і жоден більше не несе її блок).',
        refusal: 'Відмова',
        warning: 'Попередження',
        generation: 'покоління документа {n}',
        state: {
          manual: 'Ручний',
          derived: 'Похідний',
          diverged: 'Розбіжний'
        },
        topologyTitle: 'Оголошена топологія',
        members: 'члени',
        primary: 'первинний',
        held: 'утримано на ОДНОМУ члені',
        form: {
          perNetworkBond: 'Бонд на мережу',
          singleBond: 'Єдиний резервний бонд',
          laggBond: 'LACP-бонд (LAGG)',
          singlePort: 'Одиночний порт'
        },
        colAction: 'Дія',
        colKind: 'Вид',
        colDevice: 'Device',
        colDetail: 'Деталь',
        action: {
          add: 'додати',
          remove: 'прибрати',
          replace: 'замінити'
        },
        diffEmpty: 'Немає очікуваного diff — застосований документ збігається з рендером.',
        diffBlocked: 'Немає diff: відмови вище блокують цей вузол.',
        phasePlanned: 'заплановано (крок 1 з 3)',
        phaseDraining: 'осушується (крок 2 з 3)',
        probeUnobserved: 'Зонд осушення: ніколи не повідомлявся — порожнеча НЕВІДОМА (retire зараз було б відхилено).',
        probeFailed: 'Зонд осушення: спостереження ПРОВАЛИЛОСЯ — відомі мітки часу переносяться, ніколи «порожньо», якого ніхто не виміряв.',
        probeActive: {
          one: 'Зонд: {n} встановлене з\'єднання досі на старій адресі',
          few: 'Зонд: {n} встановлені з\'єднання досі на старій адресі',
          many: 'Зонд: {n} встановлених з\'єднань досі на старій адресі',
          other: 'Зонд: {n} встановленого з\'єднання досі на старій адресі'
        },
        probeLastActive: 'остання активність {time}',
        probeEmpty: {
          one: 'Зонд: порожньо {n} хвилину',
          few: 'Зонд: порожньо {n} хвилини',
          many: 'Зонд: порожньо {n} хвилин',
          other: 'Зонд: порожньо {n} хвилини'
        },
        probeEmptyUnknown: 'Зонд: порожньо (відколи — невідомо).',
        impact: '{nics} vNIC і {apps} App на цьому вузлі використовують ці мережі: {list}',
        apply: 'Застосувати на цьому вузлі',
        applyTitle: 'Застосувати деривацію — {node}',
        applyIntro: 'Похідна конфігурація переписує мережевий документ вузла {node} ({n} змін) через ті самі двері, що й редактор host-network — включно з checkpoint NetworkManager і чесним зондом. Попередження плану нижче їдуть разом з актом: прочитайте їх перед підтвердженням.',
        applyError: 'Apply не вдався',
        applyRefused: 'Вузол відмовив:',
        planMoved: 'Fabric змінилася після цього передперегляду — НІЧОГО не було застосовано. План перезавантажено: подивіться знову і повторіть.',
        retire: 'Вивести',
        retireTitle: 'Точка неповернення — виведення {address}',
        restore: 'Відновити',
        restoreTip: 'Назад до знімка перед apply (покоління {previous}) — скасування на один крок (H13)',
        restoreTitle: 'Відновити попередній документ — {node}',
        restoreIntro: 'Мережевий документ вузла {node} повертається до знімка, зробленого перед останнім apply (покоління {previous}), переписаного як покоління {next} замість {current}. Worker зводить його як будь-який інший документ.',
        restoreRedo: 'Замінений документ стає новим знімком: повторне відновлення — це redo.',
        restoreClosesChain: 'Знімок — це ручний документ до деривації: ланцюжок закривається тут — далі скасування немає, вузол лишається ручним до наступного apply.',
        restoreConfirm: 'Відновити',
        restoreError: 'Відновлення не вдалося',
        retireIntro: 'Це остаточно прибирає {address} ({network}) з {point}. Після цього акту шлях назад — ЗВОРОТНИЙ фліп: заново оголосити стару адресу через той самий рушій — ніколи сліпе відновлення.',
        retireOld: 'Стара адреса (прибрана)',
        retireNew: 'Нова адреса (залишається)',
        retireEmptyFact: 'Зонд осушення повідомляє адресу порожньою: це виведення не рве жодного спостережуваного з\'єднання.',
        retireConfirm: 'Вивести адресу',
        severActiveLoss: {
          one: 'Обірвати {n} встановлене з\'єднання досі на старій адресі — воно помирає з цим актом',
          few: 'Обірвати {n} встановлені з\'єднання досі на старій адресі — вони помирають з цим актом',
          many: 'Обірвати {n} встановлених з\'єднань досі на старій адресі — вони помирають з цим актом',
          other: 'Обірвати {n} встановленого з\'єднання досі на старій адресі — вони помирають з цим актом'
        },
        severUnknownLoss: 'Прийняти НЕВІДОМЕ: зонд ніколи не спостерігав цю адресу (або спостереження провалюється) — живі з\'єднання можуть бути обірвані.'
      },
      title: 'Фабрика',
      createTitle: 'Створити фабрику',
      networks: 'Мережі',
      switches: 'Комутатори',
      ports: 'Порти',
      laggs: 'LAGG',
      subnets: 'Підмережі',
      tabOverview: 'Огляд',
      tabNetworks: 'Логічні мережі',
      tabSwitches: 'Комутатори',
      overviewHint: 'Фабрика з першого погляду: кожна логічна мережа з MTU та підмережею (VLAN живуть лише у зіставленнях на порт чи на LAGG — та сама мережа може їздити з різними тегами на різних портах). Фабрика — це реєстр ЗОВНІШНЬОЇ інфраструктури: TVirt спостерігає й оголошує, ніколи не робить провізіонування і чіпає лише ті NIC, які зареєстровані під його контролем.',
      absorptionHint: 'Кожна оголошена тут підмережа ВИВОДИТЬ свій запис у реєстрі IPAM тим самим записом — вона живе і вмирає разом із мережею.',
      scopeFixedHint: 'Скоуп зафіксовано в корені кластера: фізична інфраструктура за визначенням спільна для всього кластера.',
      networksHint: 'Кожна мережа несе обов’язкову MTU (типово 1500) та обов’язкову підмережу; шлюз, сервери DNS і статичні маршрути, оголошені тут, є ЄДИНИМ ДЖЕРЕЛОМ для NIC серверів, застосунків і мережевих служб.',
      switchesHint: 'Ручний реєстр: порт або не використовується, або зіставлений (трафік без тегу та за тегом VLAN на логічні мережі), або є учасником LAGG — учасник власних зіставлень не несе.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Обов’язковий — IPAM автоматично виводить із нього запис реєстру',
      nodeAddressing: 'Адресація вузлів',
      nodeAddressingNone: 'Немає — без адреси для вузла',
      nodeAddressingPool: 'Пул — одна закріплена адреса на кожен обслужений вузол',
      nodeAddressingHint: 'З Пул деривація фабрики призначає кожному обслуженому вузлу адресу з діапазонів, зарезервованих для TVirt (закріплюється після призначення).',
      backing: 'Backing',
      gateway: 'Шлюз',
      ranges: 'Зарезервовані діапазони',
      dns: 'Сервери DNS (через кому)',
      dnsShort: 'DNS',
      singleSourceHint: 'Шлюз, DNS і маршрути, оголошені тут, є єдиним джерелом — NIC серверів, застосунки та мережеві служби беруть їх звідси',
      routesTitle: 'Статичні маршрути',
      routeDestination: 'Призначення (CIDR)',
      routeVia: 'Через (наступний перехід)',
      portUsed: 'Використана',
      vlanMappings: 'Зіставлення VLAN',
      vlanTag: 'Тег VLAN',
      vlanNetwork: 'Логічна мережа',
      nameTaken: 'Назва вже використана у фабриці',
      addNetwork: 'Додати мережу',
      editNetwork: 'Змінити мережу',
      deleteNetwork: 'Вилучити мережу',
      deleteNetworkConfirm: 'Вилучити логічну мережу {name} з фабрики? Її виведена підмережа в IPAM вмирає разом із нею (буде відхилено, доки її використовує служба або застосунок). Прив\'язки портів і LAGG, що вказують на неї, очищаються.',
      switchName: 'Комутатор',
      portName: 'Порт',
      positionHint: 'Фізичне розташування (необов’язково) — той самий словник, що й для розміщення серверів; суто декларативне',
      addSwitch: 'Додати комутатор',
      editSwitch: 'Змінити комутатор',
      deleteSwitch: 'Вилучити комутатор',
      deleteSwitchConfirm: 'Вилучити комутатор {name} з усіма його портами? LAGG відповідно звузяться (і зникнуть, якщо портів лишиться менше двох).',
      addPort: 'Додати порт',
      editPort: 'Змінити порт',
      deletePort: 'Вилучити порт',
      deletePortConfirm: 'Вилучити порт {name}?',
      untagged: 'Без тегу',
      tagged: 'З тегом (тег:мережа)',
      taggedShort: 'З тегом',
      portCabling: 'Кабелювання',
      portState: 'Стан',
      stateUnused: 'не використовується',
      stateMapped: 'зіставлена',
      laggPortGuard: 'Порт, що є учасником LAGG, змінюється з боку LAGG',
      laggsTitle: 'LAGG',
      laggsHint: 'LAGG — це 2+ порти в LACP, і він може перетинати комутатори (MLAG, прозоро); входять лише невикористані порти, LAGG є поверхнею зіставлення, а вилучений порт знову стає невикористаним.',
      addLagg: 'Додати LAGG',
      editLagg: 'Змінити LAGG',
      deleteLagg: 'Вилучити LAGG',
      deleteLaggConfirm: 'Вилучити LAGG {name}? Його порти-учасники знову стануть невикористаними.',
      lacpRate: 'Частота LACP',
      laggPorts: 'Порти-учасники (2+)',
      laggPortsHint: 'Входять лише невикористані порти — спершу звільніть зіставлений порт',
      noNetworks: 'Не оголошено жодної логічної мережі.',
      noSwitches: 'Не оголошено жодного комутатора.',
      noLaggs: 'Не оголошено жодного LAGG.',
      staleConflict: 'Інший оператор змінив цю фабрику, поки ти її редагував: збереження відхилено, щоб не стерти його роботу. Твої зміни й досі тут, недоторкані. Оновлену фабрику вже перезавантажено: підтверди ще раз, щоб застосувати їх поверх, або скасуй і подивись, що змінилося.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Лише виведене: кожна підмережа народжується з логічної мережі фабрики або з оверлею — змінюють її в джерелі. Призначені адреси показують, ХТО їх тримає; зарезервовані для TVirt діапазони є пулами автоматичного призначення.',
      search: 'Пошук за іменем, CIDR або адресою',
      empty: 'Немає жодної мережі — оголосіть логічну мережу фабрики або підмережу оверлею: IPAM автоматично виводиться з них.',
      reserved: 'Діапазони, зарезервовані для TVirt',
      address: 'Адреса',
      origin: 'Походження',
      origin_declared: 'оголошено',
      origin_observed: 'спостережено',
      holder: 'Тримає',
      noAddresses: 'У цій підмережі немає відомих адрес.',
      sourceFabric: 'Фабрика',
      sourceOverlay: 'Оверлей',
      editAtSource: 'Змінити в джерелі'
    },
    firewall: {
      title: 'Групи брандмауера',
      createTitle: 'Нова група брандмауера',
      editTitle: 'Змінити групу брандмауера',
      empty: 'Жодної групи брандмауера — створіть одну: повторно використовуваний словник правил, на який гостьові NIC посилаються за іменем.',
      nameHint: 'Літери, цифри та внутрішні . - _; назва унікальна в межах свого скоупу (однойменні групи деінде розрізняє запис /скоуп/назва)',
      description: 'Опис',
      descriptionHint: 'Один рядок наміру, показуваний скрізь, де обирають групу',
      enforced: 'Обов’язкова в скоупі',
      enforcedHint: 'Вимкнено: чистий словник — правила зв’язують лише ті NIC, що посилаються на групу. Увімкнено: правила зв’язують кожну гостьову NIC з увімкненим брандмауером під скоупом групи, з посиланням чи без.',
      enforcedChip: 'Обов’язкова',
      enforcedChipHint: 'Правила зв’язують кожну гостьову NIC з увімкненим брандмауером під скоупом групи, з посиланням чи без',
      enforceWarning: 'Якщо ввімкнути обов’язковість, правила зв’яжуть КОЖНУ гостьову NIC з увімкненим брандмауером під {scope} під час наступного узгодження, навіть без явного посилання — а всередині активної chain drop предка остаточний: рівні нижче його не відкриють знову.',
      unenforceInfo: 'Якщо зняти обов’язковість, правила залишаться лише на тих NIC, що посилаються на групу явно.',
      rules: 'Правила',
      tabOverview: 'Огляд',
      tabRules: 'Правила',
      orderHint: 'Порядок рядків — це і Є порядок оцінювання всередині групи: перемагає перше правило, що збігається.',
      statefulHint: 'Stateful неявний: відповіді на допущений трафік проходять самі (established/related приймаються, invalid відкидається — їх вставляє рушій, вручну вони не пишуться).',
      noRules: 'Жодного правила — словник у побудові: посилатися на нього дозволено, і це нічого не рендерить.',
      addRule: 'Додати правило',
      direction: 'Напрямок',
      directionIn: 'Вхідний',
      directionOut: 'Вихідний',
      action: 'Дія',
      action_accept: 'Прийняти',
      action_drop: 'Відкинути',
      action_reject: 'Відхилити',
      protocol: 'Протокол',
      protocolAny: 'Будь-який',
      ports: 'Порти',
      source: 'Джерело',
      dest: 'Призначення',
      comment: 'Коментар',
      addressHint: 'CIDR IPv4 або <фабрика>/<логічна мережа>; порожнє = будь-яка',
      moveUp: 'Пересунути вгору',
      moveDown: 'Пересунути вниз',
      nicFirewall: 'Брандмауер',
      nicAntiSpoof: 'Антиспуфінг',
      nicGroups: 'Групи брандмауера',
      nicGroupsPlaceholder: 'Виберіть групу…',
      nicGroupsHint: 'Видимі групи, включно з групами вищих скоупів (придатні донизу, як теги)',
      nicGroupCount: { one: '{n} група брандмауера', few: '{n} групи брандмауера', many: '{n} груп брандмауера', other: '{n} групи брандмауера' },
      nicOff: 'Брандмауер вимкнено',
      pendingRestartHint: 'Зміни брандмауера йдуть за моделлю збережено/застосовано: вони чекають наступного циклу живлення (PendingRestart). Групи, обов’язкові з вищих скоупів, застосовуються, коли брандмауер NIC увімкнено.',
      appConvergeHint: 'Зміни брандмауера застосовуються під час наступного узгодження контейнера. Групи, обов’язкові з вищих скоупів, застосовуються, коли брандмауер увімкнено.',
      enforcedAncestors: 'Обов’язкові з вищих скоупів',
      enforcedAncestorsHint: 'Ця група застосовується до кожної NIC під своїм скоупом з УВІМКНЕНИМ брандмауером — перемикач є головним вимикачем NIC (вимкнено = жодної chain, предки включно); всередині активної chain авторитет предка остаточний: його drop нижче не відкривається знову.'
    }
  }
}
